export const showCompensationAsOptions = {
  RANGE: 'Range',
  STARTING_AT: 'Starting at',
  UP_TO: 'Up to',
  EXACT_AMOUNT: 'Exact amount',
};

export type ShowCompensationAsId = keyof typeof showCompensationAsOptions;
